export const agentAttorneyMappingTo9035SectionE = {
  name: 'Agent/Attorney Profile Form Mapping',
  machine_name: 'agent_attorney_9035_profile_mapping',
  targetFormDetailName: 'LCA-9035',
  targetSectionName: 'Attorney or Agent Information <br/>(if applicable)',
  targetSectionLabel: 'E',
	fields: [
    {
      profileFieldName: 'new_profile_individual_agent_type_id',
      formTargetField: 'e1_is_represented'
    },
    {
      profileFieldName: 'new_profile_individual_agent_last_name',
      formTargetField: 'e2_agent_last'
    },
    {
      profileFieldName: 'new_profile_individual_agent_first_name',
      formTargetField: 'e3_agent_first'
    },
    {
      profileFieldName: 'new_profile_individual_agent_middle_name',
      formTargetField: 'e4_agent_middle'
    },
    {
      profileFieldName: 'new_profile_individual_agent_address_1',
      formTargetField: 'e5_agent_address_1'
    },
    {
      profileFieldName: 'new_profile_individual_agent_address_2',
      formTargetField: 'e6_agent_address_2'
    },
    {
      profileFieldName: 'new_profile_individual_agent_city',
      formTargetField: 'e7_agent_city'
    },
    {
      profileFieldName: 'new_profile_individual_agent_state_id',
      formTargetField: 'e8_agent_state_id'
    },
    {
      profileFieldName: 'new_profile_individual_agent_zip',
      formTargetField: 'e9_agent_zip'
    },
    {
      profileFieldName: 'new_profile_individual_agent_country_id',
      formTargetField: 'e10_agent_country_id'
    },
    {
      profileFieldName: 'new_profile_individual_agent_province',
      formTargetField: 'e11_agent_province'
    },
    {
      profileFieldName: 'new_profile_individual_agent_phone',
      formTargetField: 'e12_agent_phone'
    },
    {
      profileFieldName: 'new_profile_individual_agent_phone_ext',
      formTargetField: 'e13_agent_phone_ext'
    },
    {
      profileFieldName: 'new_profile_individual_agent_firm_name',
      formTargetField: 'e15_agent_firm_name'
    },
    {
      profileFieldName: 'new_profile_individual_agent_email',
      formTargetField: 'e14_agent_email'
    },
    {
      profileFieldName: 'new_profile_individual_agent_firm_fein',
      formTargetField: 'e16_agent_firm_fein'
    },
    {
      profileFieldName: 'new_profile_individual_agent_bar_number',
      formTargetField: 'e17_agent_bar_number'
    },
    {
      profileFieldName: 'new_profile_individual_agent_court_state_id',
      formTargetField: 'e18_agent_court_state_id'
    },
    {
      profileFieldName: 'new_profile_individual_agent_court_name',
      formTargetField: 'e19_agent_court_name'
    }
  ]
};
